<template
  ><router-link v-if="enabled" class="ai-entry" :to="{ path: '/ai', query: { from: $route.fullPath } }"
    ><ai-icon name="spark" /><ai-name /></router-link
  ></template
>
<script>
import { entryVisible } from '@/ai/state/preferences'
import AiName from '@/components/content/brand/AiName.vue'
import AiIcon from '@/components/common/icons/AiIcon.vue'
import { supportsAi } from '@/ai/services/api'
export default {
  components: { AiName, AiIcon },
  data: () => ({ showEntry: entryVisible() }),
  activated() { this.showEntry = entryVisible() },
  watch: { '$route.fullPath'() { this.showEntry = entryVisible() } },
  computed: {
    enabled() {
      return Boolean(this.showEntry && this.$store.getters.getToken && supportsAi())
    }
  }
}
</script>
<style scoped>
.ai-entry {
  position: fixed;
  right: 25px;
  bottom: 88px;
  z-index: 30;
  display: flex;
  align-items: center;
  gap: 8px;
  border: 1px solid #ebe6ff;
  border-radius: 24px;
  background: linear-gradient(130deg, #fff, #eeebff);
  color: #7770ba;
  padding: 12px 18px;
  box-shadow: 0 6px 25px #7770ba25;
  font-size: 13px;
  text-decoration: none;
  backdrop-filter: blur(16px);
}
.ai-entry:focus-visible {
  outline: 2px solid #8c84df;
  outline-offset: 3px;
}
@media (max-width: 700px) {
  .ai-entry {
    right: 15px;
    bottom: 85px;
    padding: 11px 14px;
  }
}
</style>
